import Swal from 'sweetalert2'

import { lang } from '../../assets/lang'
import { ecommerceHtml } from './ecommerceHtml'
import {
  handleDataOfDelay,
  handleOldDataOfDelay,
  sweetAlertCommonParams,
} from '../../functions/utils'

export const ecommerceModal = async (oldData, node) => {
  const commonParams = sweetAlertCommonParams(node)
  
  return await Swal.fire({
    ...commonParams,
    title: lang.ecommerce_modal_title,
    html: ecommerceHtml,

    willOpen: () => {
      $('.select2').select2({ 
        width: '100%',
        dropdownParent: $('#swal2-content')
      })

      // TODO
      // Load and dump select options via ajax call
      var page_table_id = window.xitFlowBuilderData.page_table_id
      var base_url = window.xitFlowBuilderData.base_url
      $.ajax({
        type: 'POST',
        url: base_url+'visual_flow_builder/get_store_list',
        dataType: 'JSON',
        data: { page_table_id },
        success:function(response){
          $("#ecommerce-ecommerce-store").html(response.store_list)
          $('#ecommerce-ecommerce-store').val(oldData.ecommerceStoreValue || '').trigger('change')
        }
      })

      $("#ecommerce-ecommerce-store").on('change', function(e) {
        const selectedStoreId = e.target.value
        if(selectedStoreId)
        {
          $.ajax({
            type: 'POST',
            url: base_url+'visual_flow_builder/get_storewise_products',
            dataType: 'JSON',
            data: { selectedStoreId },
            success:function(response){
              $("#ecommerce-ecommerce-product").html(response.product_list)
              $('#ecommerce-ecommerce-product').val(oldData.ecommerceProductValue || '').trigger('change')
            }
          })
        }
      })

      // Sets old data
      $('#ecommerce-ecommerce-button-text').val(oldData.ecommerceButtonTextValue || '')

      // Handles old data of delay system
      handleOldDataOfDelay(oldData)
    },

    preConfirm: () => {
      const ecommerceStoreValue = $('#ecommerce-ecommerce-store').val()
      const ecommerceStoreText = $('#ecommerce-ecommerce-store option:selected').text()

      const ecommerceProductValue = $('#ecommerce-ecommerce-product').val()

      var ecommerceProductThumbnail = []      
      var ecommerceProductPrice = []
      var ecommerceStoreCurrency = $("#ecommerce-ecommerce-store option:selected").attr('data-currency');

      // eslint-disable-next-line
      $( "#ecommerce-ecommerce-product option:selected" ).each(function( index ) {
        ecommerceProductThumbnail.push($(this).attr('data-thumbnail'));
        ecommerceProductPrice.push($(this).attr('data-price'));
      })

      if($(ecommerceProductValue).length > 1)
      {
        $("#slideshow > div:gt(0)").hide();

        // eslint-disable-next-line
        var carosuelInterval = setInterval(function() { 
          $('#slideshow > div:first')
          .hide()
          .next()
          .show()
          .end()
          .appendTo('#slideshow');
        }, 7000);        
      }

      let ecommerceProductText = []
      $('#ecommerce-ecommerce-product option:selected').map((key, val) => {
        ecommerceProductText.push(val.text)
      })

      const ecommerceButtonTextValue = $('#ecommerce-ecommerce-button-text').val()

      if (! ecommerceStoreValue) {
        Swal.showValidationMessage(lang.ecommerce_modal_msg_store)
      } else if (ecommerceProductValue.length < 1) {
        Swal.showValidationMessage(lang.ecommerce_modal_msg_product)
      } else if (! ecommerceButtonTextValue) {
        Swal.showValidationMessage(lang.ecommerce_modal_msg_button_name)
      }

      // Handles data of delay system
      const delayData = handleDataOfDelay()

      return {
        ecommerceStoreValue,
        ecommerceStoreText,
        ecommerceProductValue,
        ecommerceProductText,
        ecommerceButtonTextValue,
        ecommerceProductThumbnail,
        ecommerceProductPrice,
        ecommerceStoreCurrency,
        ...delayData,
      }
    },
  })
}